export default [
    {
        path: '/signRecord',
        component: () => import('@/views/register/signRecord/signRecord'),
    },
]